module.exports = __webpack_public_path__ + "static/media/feature_2.032185ef.jpg";